// owner: seo-domain agent — zod schemas + inferred types shared by api and web
import { z } from 'zod';

/** `/sitemap-{kind}-{n}.xml` path segment. */
export const SitemapFileParamsSchema = z.object({
  file: z.string().regex(/^sitemap-[a-z]+-[0-9]+\.xml$/),
});

/** `/llms-full.txt?page=N` (1-based). */
export const LlmsFullQuerySchema = z.object({
  page: z.coerce.number().int().min(1).max(100_000).default(1),
});

/** robots.txt takes no parameters; unknown query keys are ignored. */
export const RobotsQuerySchema = z.object({});

export type LlmsFullQuery = z.infer<typeof LlmsFullQuerySchema>;
